import type { ExpRateChartSnapshot } from '@/domain/types'

/** Stable miniature for the production skin picker. */
export function expChartSample(): ExpRateChartSnapshot {
  const to = 1_800_000
  return { from: to - 300_000, to, average: 304_400,
    points: [280, 285, 290, 295, 291, 287, 283, 294, 305, 316, 321, 326, 330, 328, 327, 325, 319, 314, 308, 317, 326, 335, 340, 345, 349, 346, 344, 341, 347, 353, 358].map((v, i) => ({ at: to - 300_000 + i * 10_000, value: v * 1000, segment: 0 })),
    gaps: [], recent: { value: 372_400, at: to, windowStartAt: to - 60_000, status: 'ready' } }
}
